// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"Skeleton_skeletonContainer__AUsEX","skeletonRow":"Skeleton_skeletonRow__Hybd1"};